import { render } from "./DocumentsTechnical.vue?vue&type=template&id=46a08397&scoped=true"
import script from "./DocumentsTechnical.vue?vue&type=script&lang=js"
export * from "./DocumentsTechnical.vue?vue&type=script&lang=js"

import "./DocumentsTechnical.vue?vue&type=style&index=0&id=46a08397&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a08397"]])

export default __exports__